// user history
interface UserApi {
	onChange: () => void;
	addView: (id: number) => void;
	addListened: (id: number) => void;
	getProductsHistory: (ids: Array<number>) => void;
	saveHistory: () => void;
}
interface User {
	history: {
		products: {
			[id: number]: {
				viewed?: boolean;
				listened?: boolean;
				link?: string;
			};
		};
	};
}
if (!localStorage.user) {
	const user: User = {
		history: {
			products: {},
		},
	};
	localStorage.setItem("user", JSON.stringify(user));
}
const userApi: UserApi = {
	onChange: () => {
		console.log("userApi.onChange9");
		const user: User = JSON.parse(<string>localStorage.getItem("user"));
		if (user?.history?.products) {
			Object.keys(user.history.products).forEach((prodId) => {
				const jsProduct = document.querySelector<HTMLElement>(
					`.jsProduct[data-id="${prodId}"]`
				);
				const item = user.history.products[parseInt(prodId)];
				if (jsProduct) {
					const jsViews = jsProduct.querySelectorAll(`.jsViews`);
					if (jsViews && item?.viewed) {
						jsViews.forEach((el) => el.classList.add("iconActive"));
					}

					const jsListened = jsProduct.querySelectorAll(
						`.jsListened`
					);
					if (jsListened && item?.listened) {
						jsListened.forEach((el) =>
							el.classList.add("iconActive")
						);
					}

					const jsLinkDownload = jsProduct.querySelectorAll<HTMLElement>(
						".jsLinkDownload"
					);
					if (jsLinkDownload && item?.link) {
						jsLinkDownload.forEach((el) => {
							el.classList.add("iconActive");
							el.onclick = () => {
								location.pathname = `/order/${item.link}`;
							};
						});
					}
				}
			});
		}
	},
	addView: (prodId: number) => {
		const user: User = JSON.parse(<string>localStorage.getItem("user"));
		if (!user?.history?.products?.[prodId]) {
			user.history.products[prodId] = {};
		}
		if (!user?.history?.products?.[prodId]?.viewed) {
			user.history.products[prodId].viewed = true;
			localStorage.setItem("user", JSON.stringify(user));
			userApi.onChange();
			userApi.saveHistory();
		}
	},
	addListened: (prodId: number) => {
		console.log("addListened");
		const user: User = JSON.parse(<string>localStorage.getItem("user"));
		if (!user?.history?.products?.[prodId]) {
			user.history.products[prodId] = {};
		}
		if (!user?.history?.products?.[prodId]?.listened) {
			console.log("addListened not listened");
			user.history.products[prodId].listened = true;
			localStorage.setItem("user", JSON.stringify(user));
			userApi.onChange();
			userApi.saveHistory();
		}
	},
	getProductsHistory: (ids) => {
		console.log("getProductsHistory");
		fetch(`/ajax-api/user.php`, {
			method: "post",
			body: JSON.stringify({
				action: "getHistory",
				type: "products",
				ids: ids,
			}),
		})
			.then((res) => res.json())
			.then((res) => {
				console.log("getHistory res", res);
				const user: User = JSON.parse(
					<string>localStorage.getItem("user")
				);
				const products = Object.assign(
					user.history.products,
					res.products
				);
				user.history.products = products;
				localStorage.setItem("user", JSON.stringify(user));
				console.log({ user });
				userApi.onChange();
			});
	},
	saveHistory: () => {
		// save new action to db
		const user: User = JSON.parse(<string>localStorage.getItem("user"));
		fetch(`/ajax-api/user.php`, {
			method: "post",
			body: JSON.stringify({
				action: "updateHistory",
				type: "products",
				products: user.history.products,
			}),
		})
			.then((res) => res.json())
			.then((res) => {
				console.log("saveHistory res", res);
				// const user: user = JSON.parse(
				//     <string>localStorage.getItem("user")
				// );
				// user.history.products = res.products;
				// localStorage.setItem("user" , JSON.stringify(user));
				// console.log({user});
				// userApi.onChange();
			});
	},
};
userApi.onChange();

if (!(<any>window).isUserHaveHistory && localStorage.user) {
	// upload user history from localStorage to db
	const user: User = JSON.parse(<string>localStorage.getItem("user"));
	if (user.history.products) {
		fetch(`/ajax-api/user.php`, {
			method: "post",
			body: JSON.stringify({
				action: "setHistory",
				history: user.history,
			}),
		})
			.then((res) => res.json())
			.then((res) => {
				console.log("upload user history res2", res);
			});
	}
} else {
	// get user products history
	const jsProduct = document.querySelectorAll<HTMLElement>(`.jsProduct`);
	if (jsProduct) {
		const ids: Array<number> = [];
		jsProduct.forEach((x) => {
			ids.push(parseInt(x.dataset.id + ""));
		});
		userApi.getProductsHistory(ids);
	}
}
// END user history
(<any>window).userApi = userApi;

export default userApi;
